import { mediaMin } from '@spa/shared/theme';
import styled from 'styled-components';

export const Wrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 ${props => props.theme.space(3)};
  width: auto;
  min-width: 50px;
  height: ${props => (props.isSmall ? '32px' : '40px')};
  overflow: visible;
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(14)};
  font-weight: 600;
  line-height: normal;
  border: none;
  border-radius: 8px;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
  }

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  & > svg:first-child {
    margin-right: ${props => props.theme.space(3)};

    ${props =>
      !props.isMobile &&
      mediaMin.largeBreakpoint`
      margin-right: 0;
    `}
  }

  & > svg:last-child {
    margin-left: ${props => props.theme.space(3)};

    ${mediaMin.largeBreakpoint`
      margin-right: 0;
    `}
  }

  ${props =>
    !props.isMobile &&
    mediaMin.largeBreakpoint`
    & > span {
      display: none;
    }
  `}

  ${props =>
    props.isPrimary &&
    `
    background-color: ${props.theme.buttons.primary.background};
    color: ${props.theme.buttons.primary.color};

    &:hover {
      background-color: ${props.theme.buttons.primary.hover};
    }
  `}

  ${props =>
    props.isSecondary &&
    `
    background: ${props.theme.buttons.secondary.background};
    border: 1px solid ${props.theme.buttons.secondary.border};
    color: ${props.theme.buttons.secondary.color};

    &:hover {
      background-color: ${props.theme.buttons.secondary.hover};
    }
  `}

  ${props =>
    props.isTertiary &&
    `
    background: ${props.theme.buttons.tertiary.background};
    box-shadow: 0 0 0 1px ${props.theme.buttons.tertiary.border};
    color: ${props.theme.buttons.tertiary.color};

    &:hover {
      background-color: ${props.theme.buttons.tertiary.hover};
    }

    ${props.isMobile &&
      `
      flex-grow: 1;
    `}

    ${props.isSelected &&
      `
      display: flex;
      background: ${props.theme.buttons.tertiary.backgroundSelected};
      box-shadow: 0px 0px 0px 1.5px ${props.theme.buttons.tertiary.selected};
      color: ${props.theme.buttons.tertiary.selectedColor};

      &:hover {
        background-color: ${props.theme.buttons.tertiary.backgroundSelected};
        box-shadow: 0px 0px 0px 2px ${props.theme.buttons.tertiary.selected};
      }
    `}
  `}

  ${props =>
    props.isDanger &&
    `
    background: ${props.theme.buttons.danger.background};
    color: ${props.theme.buttons.danger.color};

    &:hover {
      background-color: ${props.theme.buttons.danger.hover};
    }
  `}

  ${props =>
    props.isGhost &&
    `
    background: ${props.theme.buttons.ghost.background};
    color: ${props.theme.buttons.ghost.color};

    &:hover {
      background-color: ${props.theme.buttons.ghost.hover};
    }
  `}
`;
